import React, { useState } from 'react';
import { signInWithEmailAndPassword, signOut } from "firebase/auth";
import { doc } from 'firebase/firestore';
import { getDocFromServer } from '../utils/firestoreRead';
import { limpiarCacheAutorizacion } from '../utils/authProfile';
import { auth, db } from '../firebase/firebaseConfig';
import { useNavigate, Link } from 'react-router-dom';
import './login.css';

import { normalizarRol } from '../utils/roles';
import { leerUsuario } from '../utils/legacyData';

export default function Login() {
  const [email, setEmail] = useState('');
  const [contrasena, setContrasena] = useState('');
  const [verPass, setVerPass] = useState(false);
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!email || !contrasena) {
      setError('Completa correo y contraseña');
      return;
    }

    setError('');
    setCargando(true);
    limpiarCacheAutorizacion();

    try {
      const cred = await signInWithEmailAndPassword(auth, email.trim(), contrasena);
      const uid = cred.user.uid;

      const ref = doc(db, 'usuarios', uid);
      const snap = await getDocFromServer(ref);

      if (!snap.exists()) {
        setError('No se encontró información del usuario.');
        setCargando(false);
        return;
      }

      const datos = leerUsuario(snap.data(), uid);
      if (!datos) { await signOut(auth); setError('No existe un perfil operativo registrado.'); return; }
      if (datos.activo === false) {
        limpiarCacheAutorizacion();
        await signOut(auth);
        setError('Tu usuario está desactivado. Contacta al administrador.');
        setCargando(false);
        return;
      }
      const rol = normalizarRol(datos.rol || 'pendiente');
      const empresaId = datos.empresaId || null;
      const empresaNombre = datos.empresaNombre || '';
      const empresasPermitidas = Array.isArray(datos.empresasPermitidas)
        ? datos.empresasPermitidas
        : empresaId
          ? [empresaId]
          : [];

      localStorage.setItem(
        'usuario',
        JSON.stringify({
          nombre: datos.nombre || 'Usuario',
          email: datos.email || cred.user.email || email.trim(),
          rol,
          uid,
          empresaId,
          empresaNombre,
          empresasPermitidas,
          eventosPermitidos: datos.eventosPermitidos || {},
          eventosBloqueados: datos.eventosBloqueados || {},
        })
      );

      switch (rol) {
        case 'owner':
          navigate('/dashboard/owner');
          break;
        case 'socio':
          navigate('/dashboard/socio');
          break;
        case 'organizador':
          navigate('/dashboard/organizador');
          break;
        case 'administracion':
          navigate('/dashboard/administracion');
          break;
        case 'rrpp':
          navigate('/dashboard/rrpp');
          break;
        case 'imagen':
          navigate('/dashboard/imagen');
          break;
        case 'barra':
          navigate('/dashboard/barra');
          break;
        case 'porteria':
          navigate('/dashboard/porteria');
          break;
        default:
          navigate('/pendiente');
          break;
      }
    } catch (err) {
      const msg = String(err?.message || err);

      if (msg.includes('auth/invalid-credential')) {
        setError('Correo o contraseña incorrectos.');
      } else {
        setError('No se pudo iniciar sesión. Intenta de nuevo.');
      }

      setCargando(false);
    }
  };

  return (
    <div
      className="login login--bg"
      style={{
        backgroundImage: "url('/letrero.jpg')",
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <header className="login__brand">
        <img src="/logo.png" alt="Palmarama" className="login__logo" />
        <h1>Iniciar sesión</h1>
        <p className="muted">Acceso interno para personal</p>
      </header>

      <form className="login__form" onSubmit={handleLogin} noValidate>
        <label className="field">
          <span>Correo electrónico</span>
          <input
            type="email"
            inputMode="email"
            autoCapitalize="none"
            autoComplete="email"
            placeholder="tu@correo.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </label>

        <label className="field">
          <span>Contraseña</span>
          <div className="passwrap">
            <input
              type={verPass ? 'text' : 'password'}
              autoComplete="current-password"
              placeholder="••••••••"
              value={contrasena}
              onChange={(e) => setContrasena(e.target.value)}
              required
            />
            <button
              type="button"
              className="toggle"
              onClick={() => setVerPass((v) => !v)}
              aria-label={verPass ? 'Ocultar contraseña' : 'Mostrar contraseña'}
            >
              {verPass ? 'Ocultar' : 'Mostrar'}
            </button>
          </div>
        </label>

        {error && <div className="alert">{error}</div>}

        <button className="btn btn--primary" type="submit" disabled={cargando}>
          {cargando ? 'Ingresando…' : 'Iniciar sesión'}
        </button>

        <div className="login__links">
          <span>
            ¿No tienes cuenta? <Link to="/register">Crear una</Link>
          </span>
        </div>
      </form>

      <footer className="login__foot">
        © {new Date().getFullYear()} Palmarama · Uso interno
      </footer>
    </div>
  );
}
